const statesUrl = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados'

export { statesUrl }
